export default __webpack_public_path__ + "static/media/811.e14beb90.png";